export class UxPreloader {
    constructor() {
        this.showListeners = [];
        this.hideListeners = [];
    }
    show() {
        this.triggerOnShowListeners();
    }
    onShow(callback) {
        this.showListeners.push(callback);
    }
    removeOnSHow(callback) {
        const index = this.showListeners.indexOf(callback);
        if (index) {
            this.hideListeners.splice(index, 1);
        }
    }
    triggerOnShowListeners() {
        this.showListeners.forEach((listener) => {
            listener();
        });
    }
    hide() {
        this.triggerOnHideListeners();
    }
    onHide(callback) {
        this.hideListeners.push(callback);
    }
    removeOnHide(callback) {
        const index = this.hideListeners.indexOf(callback);
        if (index) {
            this.hideListeners.splice(index, 1);
        }
    }
    triggerOnHideListeners() {
        this.hideListeners.forEach((listener) => {
            listener();
        });
    }
}
export default UxPreloader;
//# sourceMappingURL=preloader.js.map